import pointCloudRouterPaths from './pointCloudRouterPaths';

export default pointCloudRouterPaths;
